import { useRouter } from 'next/router';
import { useProduct } from '../ProductProvider';
import { getProductFaq } from '@/service/ProductCommon/getProductFaq';
import { getProductDownload } from '@/service/ProductCommon/getProductDownload';

export default function getProductSpec(generalKey: string) {
    const { state, dispatch } = useProduct();
    const { productMsg, productSupport } = state;
    const { locale = 'us' } = useRouter();

    const getData = async (generalKey: string) => {
        const product = productMsg && productMsg[generalKey];
        const resFaq = await getProductFaq({ spuId: product?.sourceId }, locale);

        const resDownload1 = await getProductDownload({ spuIds: product?.sourceId }, locale);
        const resDownload2 = await getProductDownload({ spuIds: product?.sourceId, classify: 'VIDEO_COURSE' }, locale);
        const resDownload3 = await getProductDownload({ spuIds: product?.sourceId, classify: 'ONLINE' }, locale);
        if (resFaq?.code === '0' && resDownload1?.code === '0' && resDownload2?.code === '0' && resDownload3?.code === '0') {
            dispatch({
                type: 'changeProductSupport',
                payload: {
                    ...productSupport,
                    [generalKey]: {
                        faqList: resFaq.data?.records || [],
                        downloadList: resDownload1?.data?.content || [],
                        videoList: resDownload2?.data?.content || [],
                        onlineList: resDownload3?.data?.content || [],
                    },
                },
            });
        }
    };
    if (!productSupport || !productSupport[generalKey]) {
        getData(generalKey);
    }
    return null;
}
